import React, {useEffect, useState} from "react";


import {
    PageContainerComponent, SectionContainerComponent
} from "@Components/Sections";


import "./index.scss";
import {Col, Row} from "react-bootstrap";
import {UserDashboardRefundCardComponent} from "@Pages/@@UserPages/@Dashboard/Cards";
import UserDashboardSecurityCardComponent from "./Cards/SecurityCard";


import accessTimeIcon from "@Icons/SVG/icon-access_time-s-orange.svg";
import checkIcon from "@Icons/SVG/icon-check-s-orange.svg";
import attachMoneyIcon from "@Icons/SVG/icon-attach_money-s-yellow.svg";
import showChartIcon from "@Icons/SVG/icon-show_chart-s-orange.svg";
import languageIcon from "@Icons/SVG/icon-language-s-orange.svg";
import securityIcon from "@Icons/SVG/icon-security-s-orange.svg";
import radioButtunIcon from "@Icons/SVG/icon-radio_button_checked-s-orange.svg";
import syncIcon from "@Icons/SVG/icon-sync-s-orange.svg";
import uploadFileIcon from "@Icons/SVG/icon-upload_file-s-white.svg";
import accessTimeBlueIcon from "@Icons/SVG/icon-access_time-s-blue.svg";
import checkCircleIcon from "@Icons/SVG/icon-check_circle_outline-s-green.svg";
import extraActionsIcon from "@Icons/SVG/icon-extra_action-s-grey.svg";
import uploadIcon from "@Icons/SVG/icon-file_upload-m-black.svg";
import downloadIcon from "@Icons/SVG/icon-download-s-white.svg";


import {SvgIconComponent} from "@Components/Elements";
import {ButtonComponent} from "@Components/Forms";
import {UseQyvoUser} from "@Store/@Hooks";
import {Navigate, Route, Routes} from "react-router-dom";
import {UseUserSignInAction} from "@Store/@Hooks/@@Actions";
import HomePage from "@Pages/@HomePage";
import UserDashboardHomePage from "@Pages/@@UserPages/@Dashboard/@Home";
import UserDashboardProfilePage from "@Pages/@@UserPages/@Dashboard/@Profile";
import UserDashboardConnectedAppsPage from "@Pages/@@UserPages/@Dashboard/@Apps";
import UserDashboardSettingsPage from "@Pages/@@UserPages/@Dashboard/@Settings";
import UserDashboardPrivacyAndSecurityPage from "@Pages/@@UserPages/@Dashboard/@Security";
import UserDashboardDocumentsPage from "@Pages/@@UserPages/@Dashboard/@Documents";


export const UserDashboardPage:React.FC = () => {

    const UserSignInAction = UseUserSignInAction();

    const QyvoUser = UseQyvoUser();

    const [User, setUser] = useState(null);

    useEffect(() => {

        if (!QyvoUser || QyvoUser?.qyvoUserFirstName) {
            return;
        }

        const getUser = async () => {
            try {
                const response = await fetch(
                    `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/get-user-by-email/?user_email=${QyvoUser.qyvoUserEmail}&user_data=true`
                );
                if (response.ok) {
                    const data = await response.json();
                    setUser(data);
                    UserSignInAction({
                        qyvoUserEmail: data.qyvo_user_email,
                        qyvoUserFirstName: data.qyvo_user_first_name,
                        qyvoUserLastName: data.qyvo_user_last_name,
                    });
                }
            } catch (e) {

            }
        };

        getUser();

    }, [QyvoUser]);

    if (!QyvoUser) {
        return <Navigate to={'/sign-in'} replace />;
    }


    return (
        <PageContainerComponent
            pageType={'user-dashboard'}
        >

            <Routes>

                <Route
                    index
                    element={<UserDashboardHomePage />}
                />

                <Route
                    path={'profile'}
                    element={<UserDashboardProfilePage />}
                />

                <Route path={'settings'}
                       element={<UserDashboardSettingsPage />}
                />

                <Route
                    path={'upload-documents'}
                    element={<UserDashboardDocumentsPage />}
                />

                <Route
                    path={'privacy-and-security'}
                    element={<UserDashboardPrivacyAndSecurityPage />}
                />

                <Route
                    path={'connected-apps'}
                    element={<UserDashboardConnectedAppsPage />}
                />

            </Routes>

        </PageContainerComponent>
    );


};


export default UserDashboardPage;
